<template>
  <div class="my-booklib-container">
    <component :is="componentId"></component>
  </div>
</template>

<script>
import Published from './components/Published'
import LibEdit from '@/views/libEdit'
export default {
  name: 'MyBooklib',
  components: {
    Published,
    LibEdit
  },
  computed: {
    componentId: {
      get() {
        return this.$store.state.manage.componentManager
      },
      set(value) {
        this.$store.commit('manage/UPDATE_COMPONENTMANAGER', value)
      }
    },
    userName() {
      return localStorage.getItem('username')
    },
    alreadyUse() {
      return this.$store.state.manage.alreadyUse || 0
    }
  }
}
</script>
<style lang="scss">
.my-booklib-container {
  padding-left: 18px;
  .yellow {
    color: #df5813;
  }
}
</style>
